import { questionnaireGql } from '../../../gql-gen/questionnaire'

export const REMOVE_QUESTIONNAIRE_ENTRIES = questionnaireGql(/* GraphQL */ `
  mutation removeQuestionnaireEntriesV2(
    $input: RemoveQuestionnaireEntriesV2Input!
  ) {
    removeQuestionnaireEntries: removeQuestionnaireEntriesV2(input: $input)
  }
`)
